import * as React from 'react';
import { startOfDay, getMinutes, getHours } from 'owa-datetime';
import { GridLineItemProps } from './GridLinesFragment';
import { isDateInDateRange } from 'owa-datetime-utils';
import { observableNow } from 'owa-observable-datetime';
import { formatShortHour, formatShortTime, formatWeekDayMonthDay } from 'owa-datetime';
import { observer } from 'mobx-react';

const styles = require('./GridLine.scss');
const getClassName = require('classnames/bind').bind(styles);

/** Additional class names to apply to grid lines headers */
export interface GridLineHeaderClassNames {
    /** Class name to apply to non-highlighted headers */
    default?: string;

    /** Class name to apply to highlighted headers (the one with the current time) */
    highlight?: string;
}

/**
 * Shows the time for a gridline.
 * The time parameter must be in the time zone of the corresponding column.
 */
export default observer(function GridLineHeader({
    time,
    style,
    dateRange,
    classNames,
    showIsNewDay,
}: GridLineItemProps<GridLineHeaderClassNames>) {
    const hour = getHours(time);
    if (showIsNewDay && !hour) {
        const newDayText = formatWeekDayMonthDay(time);
        return (
            <div style={style} className={styles.dayBoundaryContainer}>
                <div className={styles.dayBoundary}>{newDayText}</div>
            </div>
        );
    } else {
        const now = observableNow();
        const timeString = (getMinutes(time) ? formatShortTime : formatShortHour)(time);

        const isCurrentDateRange = isDateInDateRange(dateRange, startOfDay(now));
        const highlightHeader = isCurrentDateRange && getHours(now) == hour;

        const className = getClassName(
            styles.timeContainer,
            { currentTimeHeader: highlightHeader },
            classNames && (highlightHeader ? classNames.highlight : classNames.default)
        );

        return (
            <div style={style} className={className}>
                <time className={styles.timeItem}>{timeString}</time>
            </div>
        );
    }
});
